module.exports = __webpack_public_path__ + "img/1-11.73a8aaf9.jpg";